<template>
  <v-container
    tag="section"
  >
    <v-col
      cols="12"
      class="px-0"
    >
      <v-row
        align="stretch"
        justify="start"
      >
        <v-col
          cols="12"
        >
          <base-material-card
            color="coolrunner"
            icon="book"
            inline
            class="px-5 py-3"
          >
            <template
              v-slot:after-heading
            >
              <div class="text-h2 font-weight-light">
                {{ $t('agreement') }}
              </div>
            </template>
            <v-form>
              <v-container class="py-0">
                <v-col>
                  <v-subheader class="pl-0">
                    {{ $t('generel') }}
                  </v-subheader>

                  <v-divider />
                </v-col>
                <v-row class="mx-0">
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model="entity.name"
                      :label="$t('name')"
                    />
                  </v-col>
                </v-row>
                <v-col>
                  <v-row>
                    <v-col cols="4">
                      <base-paginated-select
                        :selected="entity.carrier"
                        endpoint="carriers"
                        :label="$t('carrier')"
                        item-text="name"
                        selected-item-text="name"
                        @value-change="updateCarrier"
                      />
                    </v-col>
                    <v-col cols="4">
                      <base-paginated-select
                        :selected="entity.currency"
                        endpoint="currencies"
                        :label="$t('currency')"
                        item-text="full_name"
                        selected-item-text="full_name"
                        @value-change="updateCurrency"
                      />
                    </v-col>
                    <v-col>
                      <v-menu
                        ref="menu_from"
                        v-model="menuFrom"
                        :close-on-content-click="false"
                        :return-value.sync="entity.valid_from_date"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="entity.valid_from_date"
                            :label="$t('from')"
                            prepend-icon="event"
                            readonly
                            dense
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="entity.valid_from_date"
                          first-day-of-week="1"
                          :max="entity.valid_to_date"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu_from.save(null)"
                          >
                            {{ $t('clear') }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="menuFrom = false"
                          >
                            {{ $t('cancel') }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu_from.save(from)"
                          >
                            {{ $t('ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col>
                      <v-menu
                        ref="menu_to"
                        v-model="menuTo"
                        :close-on-content-click="false"
                        :return-value.sync="entity.valid_to_date"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="entity.valid_to_date"
                            :label="$t('to')"
                            prepend-icon="event"
                            readonly
                            dense
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          v-model="entity.valid_to_date"
                          first-day-of-week="1"
                          :min="entity.valid_from_date"
                        >
                          <v-spacer />
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu_to.save(null)"
                          >
                            {{ $t('clear') }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="menuTo = false"
                          >
                            {{ $t('cancel') }}
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.menu_to.save(to)"
                          >
                            {{ $t('ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col
                      style="margin-left: auto;"
                      cols="4"
                    >
                      <base-file-input
                        :item="entity.file"
                        :label="$t('agreement')"
                        outlined
                        dense
                        @update="updateFile"
                      />
                    </v-col>
                  </v-row>
                  <v-col>
                    <v-row>
                      <v-btn
                        color="green"
                        bottom
                        right
                        class="ml-auto"

                        @click="save()"
                      >
                        <v-icon class="mr-3">
                          mdi-content-save
                        </v-icon>
                        {{ $t('save') }}
                      </v-btn>
                    </v-row>
                  </v-col>
                </v-col>
                <v-col>
                  <v-subheader class="pl-0">
                    {{ $t('product_products') }}
                  </v-subheader>
                  <v-divider />
                </v-col>
                <v-row class="mx-0">
                  <v-col cols="12">
                    <v-data-table
                      :headers="productHeaders"
                      :items="entity.products"
                      :footer-props="{
                        itemsPerPageOptions: [10, 20, 50, 100]
                      }"
                      dense
                      class="elevation-1"
                    >
                      <template v-slot:item.geo="{ item }">
                        <v-chip
                          :color="item.is_percentage ? 'blue' : 'green'"
                          text-color="white"
                        >
                          {{ item.country_from ? item.country_from.iso : '' }} <v-icon>mdi-arrow-right</v-icon> {{ item.country_to ? item.country_to.iso : '' }}
                        </v-chip>
                      </template>
                      <template v-slot:item.dimensions="{ item }">
                        <template>
                          {{ item.height }}<v-icon size="14">
                            mdi-close
                          </v-icon>{{ item.width }}<v-icon size="14">
                            mdi-close
                          </v-icon>{{ item.length }}
                        </template>
                      </template>
                      <template v-slot:item.weight="{ item }">
                        <v-chip
                          :color="'green'"
                          text-color="white"
                        >
                          {{ item.weight_from }} <v-icon>mdi-arrow-right</v-icon> {{ item.weight_to }}
                        </v-chip>
                      </template>
                      <template v-slot:item.cost="{ item }">
                        {{ parseFloat((item.cost || 0).toFixed(2)) }} ,-
                      </template>

                      <template v-slot:item.action="{ item }">
                        <v-icon
                          medium
                          :color="item.price_update_count ? 'green' : 'red'"
                          class="mr-2"
                          @click="item.price_update_count ? null : productUpdate.new_product_id = item.id"
                        >
                          mdi-clock
                        </v-icon>
                        <v-icon
                          medium
                          color="green"
                          class="mr-2"
                          @click="editProduct(item)"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          medium
                          color="orange"
                          class="mr-2"
                          @click="cloneProduct(item)"
                        >
                          mdi-animation-outline
                        </v-icon>
                        <v-icon
                          medium
                          color="red"
                          class="mr-2"
                          @click="deleteProduct(item)"
                        >
                          mdi-delete
                        </v-icon>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
                <v-col>
                  <v-row>
                    <v-btn
                      color="green"
                      bottom
                      right
                      class="ml-auto"

                      @click="product = {}"
                    >
                      <v-icon class="mr-3">
                        mdi-content-save
                      </v-icon>
                      {{ `${$t('add')} ${$t('product')}` }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-container>
            </v-form>
          </base-material-card>
        </v-col>

        <v-dialog
          v-if="!!productUpdate.new_product_id"
          :value="true"
          max-width="500px"
          persistent
        >
          <v-card>
            <v-card-title>
              <span class="text-h5">Vælg gammelt produkt</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-menu
                        v-model="menuActiveFrom"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="290px"
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="productUpdate.active_from"
                            :label="$t('valid_from')"
                            prepend-icon="event"
                            readonly
                            dense
                            v-on="on"
                          />
                        </template>
                        <v-date-picker
                          :value="productUpdate.active_from"
                          first-day-of-week="1"
                          @input="val => productUpdate.active_from = val"
                        >
                          <v-spacer />

                          <v-btn
                            text
                            color="primary"
                            @click="() => {
                              menuActiveFrom = false
                            }"
                          >
                            {{ $t('ok') }}
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-col>
                    <v-col cols="12">
                      <base-paginated-select
                        :selected="productUpdate.old_product"
                        endpoint="products-select"
                        :label="$t('products')"
                        item-text="title"
                        selected-item-text="title"
                        @value-change="val => {
                          productUpdate.old_product = val;
                        }"
                      />
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="yellow darken-1"
                text
                @click="resetProductUpdate"
              >
                {{ $t('cancel') }}
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :loading="loading"
                :disabled="!productUpdate.active_from || !productUpdate.old_product"
                @click="saveProductUpdate"
              >
                {{ $t('save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <product-dialog
          v-if="!!product"
          :product="product"
          @close="closeDialog"
          @save="updateProduct"
        />
      </v-row>
    </v-col>
    <base-loading-overlay :loading="loading" />
  </v-container>
</template>
<script>
  import Edit from '@/mixins/Edit'

  export default {
    components: {
      ProductDialog: () => import('./ProductDialog'),
    },

    mixins: [Edit],
    data () {
      return {
        endpoint: 'agreements',
        name: 'agreement',
        product: null,
        productUpdate: {
          old_product: null,
          new_product_id: null,
          active_from: '',
        },
        menuActiveFrom: false,
        menuFrom: false,
        menuTo: false,
        productHeaders: [
          {
            text: this.$t('id'),
            value: 'id',
          },
          {
            sortable: false,
            text: this.$t('name'),
            value: 'name',
          },
          {
            text: this.$t('product_group'),
            value: 'product_group.name',
          },
          {
            text: this.$t('geo'),
            value: 'geo',
          },
          {
            text: this.$t('dimensions'),
            value: 'dimensions',
          },
          {
            text: this.$t('weight'),
            value: 'weight',
          },
          {
            text: this.$t('cost_price'),
            value: 'cost',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },
        ],
      }
    },
    computed: {
      costSum: function () {
        let sum = 0
        for (const product of this.entity.products || []) {
          sum += parseFloat(product.final_cost)
        }
        return sum || 0
      },
      carriers: function () {
        const carriers = {}

        for (const product of this.entity.products || []) {
          const carrier = product.agreement
            ? product.agreement.carrier
            : null
          if (!carrier || !carrier.volume_weight_factor) continue

          carriers[carrier.slug || carrier.name] = carrier
        }
        return carriers
      },
    },
    methods: {
      closeDialog: function () {
        this.product = null
      },
      resetProductUpdate: function () {
        this.productUpdate = { active_from: '', new_product_id: null, old_product: null }
      },
      saveProductUpdate: function () {
        const { old_product, active_from, ...temp } = this.productUpdate
        this.$put(`/${this.endpoint}/${this.$route.params.id}/products/${this.productUpdate.new_product_id}`, { active_from, old_product_id: old_product.id }).then(() => {
          this.resetProductUpdate()
          this.load()
          this.$toast(`${this.$t('product')} ${this.$t('saved_correctly')}`)
        })
      },
      calcVolumeWeight (weightFactor) {
        return (
          (this.entity.length / 100) *
          (this.entity.width / 100) *
          (this.entity.height / 100) *
          weightFactor *
          1000
        ).toFixed(0)
      },
      checkForVolumeWeight (carriers) {
        const sum = this.$_.sum(this.$_.map(carriers, 'volume_weight_factor'))
        return sum > 0
      },
      updateCarrier: function (val) {
        this.entity.carrier = val
      },
      updateCurrency: function (val) {
        this.entity.currency = val
      },
      updateFile: function (val) {
        this.entity.file = val
      },
      updateProduct (product) {
        if (!product.id && !this.canCreate()) { return }
        if (product.id && !this.canUpdate()) { return }

        let url = '/products'
        if (product.id) {
          url += `/${product.id}`
        } else {
          product.agreement_id = this.entity.id
        }

        product.country_from_id = product.country_from.id
        product.country_to_id = product.country_to.id
        product.product_group_id = product.product_group.id

        product.fees = this.$_.map(product.fees, fee => {
          return fee.id
        })

        this.$post(url, product)
          .then(response => {
            this.$toast(`${this.$t('product')} ${this.$t(product.id ? 'updated' : 'added')}`)
            this.closeDialog()
            const val = response.data
            const products = [...this.entity.products]

            const index = this.$_.findIndex(products, ['id', val.id])

            if (index >= 0) { products.splice(index, 1, val) } else { products.push(val) }

            this.entity.products = products
          })
      },

      deleteProduct (item) {
        if (!this.canDelete()) { return }

        const index = this.$_.findIndex(this.entity.products, c => c.id === item.id)

        if (confirm(this.$t('confirm_delete', { type: this.$t('product').toLowerCase() }))) {
          if (index >= 0) {
            this.$del(`/products/${item.id}`).then(() => {
              const products = [...this.entity.products]

              const index = this.$_.findIndex(products, ['id', item.id])

              if (index >= 0) products.splice(index, 1)

              this.entity.products = products
            })
          }
        }
      },
      editProduct (product) {
        if (!this.canUpdate()) { return }
        this.product = product
      },
      cloneProduct (item) {
        if (!this.canCreate()) { return }

        const { id, ...product } = item
        this.product = product
      },
    },
  }
</script>
